<template>
  <div class="language-switcher">
    <label>{{ t('message.language') }}: </label>
    <select v-model="currentLocale" @change="changeLanguage">
      <option value="zh-CN">{{ t('message.chinese_simplified') }}</option>
      <option value="en-US">{{ t('message.english') }}</option>
      <option value="vi-VN">{{ t('message.vietnamese') }}</option>
      <option value="zh-TW">{{ t('message.chinese_traditional') }}</option>
    </select>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

export default {
  name: 'LanguageSwitcher',
  setup() {
    const { locale, t } = useI18n()
    const currentLocale = ref(locale.value)

    const changeLanguage = () => {
      locale.value = currentLocale.value
      // 更新 <html lang> 便于 SEO 与无障碍
      document.documentElement.lang = currentLocale.value
      // 保存语言选择
      localStorage.setItem('locale', currentLocale.value)
      // 同步到 URL，生成可索引/可分享的语言版本地址（如 /?lang=en-US）
      const url = new URL(window.location.href)
      url.searchParams.set('lang', currentLocale.value)
      window.history.replaceState({}, '', url)
    }

    // 初始化：URL 参数 ?lang= 优先，其次 localStorage
    const SUPPORTED = ['zh-CN', 'en-US', 'vi-VN', 'zh-TW']
    const urlParams = new URLSearchParams(window.location.search)
    const urlLang = urlParams.get('lang')
    if (urlLang && SUPPORTED.includes(urlLang)) {
      currentLocale.value = urlLang
      locale.value = urlLang
      localStorage.setItem('locale', urlLang)
    } else {
      const savedLocale = localStorage.getItem('locale')
      if (savedLocale) {
        currentLocale.value = savedLocale
        locale.value = savedLocale
      }
    }
    // 同步 <html lang>
    document.documentElement.lang = currentLocale.value

    return {
      currentLocale,
      changeLanguage,
      t
    }
  }
}
</script>

<style scoped>
.language-switcher {
  margin: 10px 0;
}
select {
  padding: 5px;
  border-radius: 4px;
  margin-left: 5px;
}
</style>